import React from 'react'
import { Outlet } from 'react-router-dom'
import { NoteV2 } from '@labrav/react-components'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.bgV2.light,
    marginInlineEnd: theme.spacing(4),
    paddingBlockStart: theme.spacing(4),
    paddingBlockEnd: theme.spacing(3),
    margin: theme.spacing(0, 4, 4, 4),
    borderRadius: theme.spacing(0, 0, 1, 1),
  },
}))

const NotificationsSettings: React.FC = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root} data-testid="notifications-setting">
      <NoteV2
        description="Below notification settings applies to all the cloud providers added
        by you."
      />
      <Outlet />
    </div>
  )
}

export default NotificationsSettings
